export default __webpack_public_path__ + "static/media/image4.d88be1c5.svg";